export function countWords(sentence: string): number {
  return sentence.trim().split(/\s+/).length;
}
